import "./chatOnline.scss";

const ChatOnline = () => {
  return (
    <div className="chatOnline">
      <div className="chatOnlineFriend">
        <div className="chatOnlineImgContainer">
          <img 
            src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" 
            alt="" 
          />
          <div className="chatBadge"></div>
        </div>
        <span>John Doe</span>
      </div>
    </div>
  );
};

export default ChatOnline;
